export default "__VITE_ASSET__B8g6mSBi__"